import axios from "axios"; 

const fetchJWT = async () => {
  try {
    // Query the API to get a JWT
    const API_URL = `${process.env.REACT_APP_API_BASE_URL}/get-jwt.php`;
    const response = await axios.get(API_URL);
    const { token } = response.data;

    if (token) {
      localStorage.setItem("jwtToken", token);
    //   console.log("JWT saved to localStorage:", token);
    } else {
      console.error("No token received from API");
    }
  } catch (error) {
    console.error("Error fetching JWT from API:", error.message);
  }
};

export default fetchJWT; 
